import { Colors, Icon, Pills, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

export interface AudienceEmployeeCountProps {
    count: number;
}

export const AudienceEmployeeCount = ({ count }: AudienceEmployeeCountProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={'w-fit'}
            data-testid={'audience-employee-count'}
        >
            <Pills
                variant={'primary'}
                className={'mt-4'}
            >
                <div>
                    <Icon
                        name={'users-people'}
                        color={Colors.WHITE}
                    />
                </div>

                <Text color={Colors.WHITE}>
                    {t('cycleEvaluationDefineAudience.displaySelectedEmployees', { count })}
                </Text>
            </Pills>
        </div>
    );
};
